// ── Utils ─────────────────────────────────────────────────────
export const gid = () => Math.random().toString(36).slice(2, 10);
export const fmt = (v) =>
  "R$ " +
  Number(v).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
export const now = new Date();
export const pad = (n) => String(n).padStart(2, "0");
export const ymd = (d) =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const ym = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}`;
export const addM = (s, n) => {
  const [y, m] = s.split("-").map(Number);
  let nm = m - 1 + n,
    ny = y;
  while (nm > 11) {
    nm -= 12;
    ny++;
  }
  while (nm < 0) {
    nm += 12;
    ny--;
  }
  return `${ny}-${pad(nm + 1)}`;
};
export const cleanCPF = (v) => v.replace(/\D/g, "");
export const fmtCPF = (v) => {
  const d = cleanCPF(v).slice(0, 11);
  return d
    .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
    .replace(/(\d{3})(\d{3})(\d{3})/, "$1.$2.$3")
    .replace(/(\d{3})(\d{3})/, "$1.$2")
    .replace(/(\d{3})/, "$1");
};
export const sysDark = () =>
  window.matchMedia?.("(prefers-color-scheme: dark)").matches;
export const MONTHS = [
  "Jan",
  "Fev",
  "Mar",
  "Abr",
  "Mai",
  "Jun",
  "Jul",
  "Ago",
  "Set",
  "Out",
  "Nov",
  "Dez",
];
export const vld = (fs) => {
  const m = fs
    .filter((f) => !f.val || !String(f.val).trim())
    .map((f) => f.label);
  return m.length ? `Preencha: ${m.join(", ")}` : "";
};
export const parseCfg = (raw) => {
  if (!raw) return null;
  if (typeof raw === "object" && raw?.projectId) return raw;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export function rebuildFat(all) {
  const base = all.filter((t) => !t.isFatura);
  const grp = {};
  base
    .filter((t) => t.creditBilled && t.ccInst)
    .forEach((t) => {
      t.ccInst.forEach((p) => {
        if (!grp[p.bym]) grp[p.bym] = { total: 0, srcs: [] };
        grp[p.bym].total += p.value;
        grp[p.bym].srcs.push({ id: t.id, desc: t.desc, value: p.value });
      });
    });
  const fats = Object.entries(grp).map(([bym, g]) => {
    const ex = all.find((t) => t.isFatura && t.date.slice(0, 7) === bym);
    return {
      id: ex?.id || gid(),
      type: "expense",
      desc: "Fatura do cartão",
      amount: +g.total.toFixed(2),
      category: "outros_exp",
      user: "Casa",
      date: `${bym}-01`,
      paid: ex?.paid || false,
      payMethod: "Débito",
      payDate: ex?.payDate || "",
      payTiming: ex?.payTiming || "",
      payAmount: ex?.payAmount || 0,
      obs: "",
      recurring: false,
      recurringId: "",
      creditBilled: false,
      isFatura: true,
      srcs: g.srcs,
    };
  });
  return [...base, ...fats];
}

export function sortItems(items, sortBy) {
  const cp = [...items];
  if (sortBy === "date_desc")
    cp.sort(
      (a, b) =>
        new Date(b.date || b.startYM || b.createdAt || "") -
        new Date(a.date || a.startYM || a.createdAt || ""),
    );
  else if (sortBy === "date_asc")
    cp.sort(
      (a, b) =>
        new Date(a.date || a.startYM || a.createdAt || "") -
        new Date(b.date || b.startYM || b.createdAt || ""),
    );
  else if (sortBy === "amount_desc")
    cp.sort(
      (a, b) =>
        (b.amount || b.totalOriginal || 0) - (a.amount || a.totalOriginal || 0),
    );
  else if (sortBy === "amount_asc")
    cp.sort(
      (a, b) =>
        (a.amount || a.totalOriginal || 0) - (b.amount || b.totalOriginal || 0),
    );
  else if (sortBy === "alpha_asc")
    cp.sort((a, b) => (a.desc || "").localeCompare(b.desc || ""));
  else if (sortBy === "alpha_desc")
    cp.sort((a, b) => (b.desc || "").localeCompare(a.desc || ""));
  return cp;
}
